import React, { useContext, useEffect, useNavigate } from "react";
import Topbar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import { Container, Tab, Tabs } from "react-bootstrap";
import Button from "../../../components/ButtonComponent/Button";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import AlertComponent from "../../../components/AlertComponent/AlertBox";
import DataTable from "../../../components/DataTableComponent/DataTable";
import UploadIcon from "../../../assets/images/uploadIcon.svg";
import RouteContants from "../../../constants/routesContent.json";
import EditIcon from "../../../assets/images/Icons/pencilIcon.svg";
import deleteIcon from "../../../assets/images/Icons/deleteIcon.svg";
import { SettingsRolesManagementContext } from "../SettingsRoleManagementView";
import { baseURL } from "../../../api/Axios";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import CenteredModal from "../../../components/CenteredModal/CenteredModal";
import { Spinner } from "react-bootstrap";
import "./settingsRoleManagement.css";

const SettingsRoleManagement = ({ textContent }) => {
  const {
    navigateToDeviceSettings,
    navigateToPermissions,
    navigateToRole,
    goBack,
    alert,
    setAlert,
    showAddRole,
    responseMessage,
    setRoleId,
    roleListData,
    setShowAddRole,
    roleListManage,
    roleName,
    setRoleName,
    createRoleData,
    isEdit,
    deleteRole,
    setIsEdit,
    addOrEdit,
    setAddOrEdit,
    editRoleData,
    navigateToRoleManagement,
    showRoleNameRequiredError,
    setShowRoleNameRequiredError,
    noAccess,
    setNoAcess,
    logout,
    spinnerStatus,
    statusCode,
    cardFileDownload,
    handleMagneticUpload,
    setFileErrorMessage,
    fileErrorMessage,
    visitorCardSubmit,
    cardExcel,
    handleAlertSubmit,
    onRoleNameChange,
  } = useContext(SettingsRolesManagementContext);

  const changeToSettings = (tab) => {
    tab === "device-settings" && navigateToDeviceSettings();
    tab === "permissions" && navigateToPermissions();
  };

  const roleHandler = [
    {
      title: "Role Name",
      prop: "RoleName",
      cell: (row) => (
        <div
          className="ertHeaderEvacuation"
          onClick={() => {
            navigateToRole(row);
          }}
        >
          {row.RoleName}
        </div>
      ),
    },
    {
      prop: "",
      cell: (row) => (
        <div className="d-flex justify-content-end">
          <img
            className="settings-edit-button mx-4"
            src={EditIcon}
            alt="Edit icon"
            onClick={() => {
              setRoleName(row.RoleName),
                setAddOrEdit("Edit Role"),
                setShowAddRole(true);
              setIsEdit(true);
              setRoleId(row.RoleId);
            }}
          />
          <img
            className="settings-delete-button"
            src={deleteIcon}
            alt="delete icon"
            onClick={() => {
              deleteRole(row.RoleId);
              setRoleId(row.RoleId);
            }}
          />
        </div>
      ),
    },
  ];

  const addorEditSubmitRole = () => {
    isEdit ? editRoleData() : createRoleData();
    // if (isEdit) addOrEdit === "Add New Role" ? createRoleData() : editRoleData();
  };

  useEffect(() => {
    roleListManage();
  }, []);

  return (
    <div className="settings">
      <Topbar />
      <Container className="my-4">
        <Tabs
          onSelect={(e) => {
            changeToSettings(e);
          }}
          defaultActiveKey="permissions"
          id="uncontrolled-tab-example"
        >
          <Tab
            eventKey="permissions"
            title={textContent.permissions.toUpperCase()}
          >
            <div className=" heading-row my-3">
              <div className="title-box">
                <img
                  onClick={() => goBack()}
                  id="arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={22}
                />
                <p className="title-name">{textContent.roleManagement}</p>
              </div>

              <Button
                onClick={() => {
                  setAddOrEdit("Add New Role");
                  setRoleName("");
                  setShowAddRole(true);
                  setIsEdit(false);
                }}
                customClass={"settings-add-new-role"}
                text={textContent.addNewRole}
              />
            </div>
            <CenteredModal
              showAddRole={showAddRole}
              showRoleNameRequiredError={showRoleNameRequiredError}
              onChangeInput={onRoleNameChange}
              onHide={() => {
                setShowAddRole(false);
                roleListManage();
                setShowRoleNameRequiredError(false);
                // navigateToRoleManagement();
              }}
              roleName={roleName}
              setRoleName={setRoleName}
              addOrEdit={addOrEdit}
              submitAddRole={() => {
                //if (roleName) {
                addorEditSubmitRole();
                roleListManage();
                //}
                if (roleName !== "") {
                  setShowAddRole(false);
                }
              }}
              setAddOrEdit={setAddOrEdit}
            />

            <div className="roleManagement">
              <DataTable
                tableData={roleListData}
                header={roleHandler}
                isPagination={false}
              />
            </div>
          </Tab>
          <Tab eventKey="visitor-card" title="VISITORS CARD">
            <div className="heading-row my-3">
              <div className="title-box">
                <img
                  className="back-arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={17}
                  onClick={() => goBack()}
                />
                <p className="title-name">{textContent.magneticTitle}</p>
              </div>
              <p className={"download-text"}>
                <a
                  className={"excel-download"}
                  href={
                    cardFileDownload
                      ? `${baseURL}/excel/${cardFileDownload}`
                      : null
                  }
                >
                  <img
                    className="excel-icon"
                    src={ExcelIcon}
                    alt="Excel-icon"
                  />
                  Download Visitors Card
                </a>
              </p>
            </div>
            <form onSubmit={visitorCardSubmit} className="uploadCradSection">
              <div className="uploadMagneticCardData">
                <label className="uploadPhotoContainerGuest">
                  <img src={UploadIcon} alt="img" />
                  <span className="uploadTextRegister">
                    {cardExcel ? cardExcel : "UPLOAD"}
                  </span>
                  <input
                    className="input-group-text"
                    type={"file"}
                    onChange={handleMagneticUpload}
                  />
                </label>
                <p className="mb-0 error-msg">
                  {fileErrorMessage ? fileErrorMessage : ""}
                </p>
              </div>
              <div className="fileSubmitBtns">
                <button type="submit" className="button">
                  {spinnerStatus ? <Spinner size="sm" /> : "Submit"}
                </button>
              </div>
            </form>
          </Tab>
          <Tab
            eventKey="device-settings"
            title={textContent.deviceSettings.toUpperCase()}
          >
            <div className="heading-row my-3">
              <div className="title-box">
                <img id="arrow" src={BackArrow} alt="Back Arrow" width={22} />
                <p className="title-name">{textContent.deviceSettings}</p>
              </div>
            </div>
          </Tab>
        </Tabs>
        {alert && (
          <AlertComponent
            show={alert}
            setShow={setAlert}
            alertMessage={responseMessage}
            handleSubmit={
              statusCode == 401
                ? () => logout()
                : () => {
                    handleAlertSubmit();

                    roleListManage();
                  }
            }
          />
        )}
        {noAccess && (
          <AlertComponent
            show={noAccess}
            setShow={setNoAcess}
            alertMessage={responseMessage}
            handleSubmit={() => {
              navigateToPermissions();
              setNoAcess(false);
              roleListManage();
            }}
          />
        )}
      </Container>
    </div>
  );
};

export default SettingsRoleManagement;
